import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstMe1: [],
		me1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getMe1Model(state){
			let me1 = { ...state.me1 }
			me1.me1datacon = Utils.ParseToDate(me1.me1datacon)
			return me1
		}
	},
	mutations: {
		set(state, me1){
			state.me1 = me1
			if (me1){
				state.update = true
				state.me1.me1datacon = new Date(state.me1.me1datacon).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			}
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.me1 = null
		},
		setParamsDataTable(state, payload){
			state.lstMe1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
			store.dispatch("me2/initForm", null, { root: true })
		},
		async find(store, me1doc){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Stock/InventoryMovement/Find/${me1doc}`)
			.then(response => {
				let me1 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", me1)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async save(store){
			if (store.state.me1.me1doc){
				return await store.dispatch("update")
			}
			return await store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Stock/InventoryMovement/Insert", store.getters.getMe1Model )
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Stock/InventoryMovement/Update", store.getters.getMe1Model )
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Stock/InventoryMovement/Delete/${store.state.me1.me1doc}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/movimentacoes-fisicas")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Stock/InventoryMovement/FindList")
			.then(response => {
				let lstMe1 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstMe1 = lstMe1
				store.state.hasNext = lstMe1.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstMe1 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Stock/InventoryMovement/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstMe1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}